var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled && _vm.resolved)?_c(_vm.resolved,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners)):(_vm.enabled && !_vm.resolved)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n  "+_vm._s(_vm.$t('core.error'))+": unknown section \""+_vm._s(_vm.name)+"\"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }